import errorMessages from "utils/validation/errorMessages";
import { emailSchema } from "utils/validation/validationHelpers";
import { object, string } from 'yup';

const loginFormSchema = object().shape({
  email: emailSchema,
  password: string().required(errorMessages.required),
});

export default loginFormSchema;